function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M170.718 216.482L141.6 245.6l93.6 93.6 208-208-29.118-29.118L235.2 279.918l-64.482-63.436zM422.4 256c0 91.518-74.883 166.4-166.4 166.4S89.6 347.518 89.6 256 164.482 89.6 256 89.6c15.6 0 31.2 2.082 45.764 6.241L334 63.6C310.082 53.2 284.082 48 256 48 141.6 48 48 141.6 48 256s93.6 208 208 208 208-93.6 208-208h-41.6z"
});

var SvgIconCheckmarkCircle = function SvgIconCheckmarkCircle(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    id: "ion-android-checkmark-circle",
    width: "100%",
    height: "100%"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-checkmark-circle.6a565a35.svg";
export { SvgIconCheckmarkCircle as ReactComponent };